'use strict';

/**
 *
 * @name: RedirectsConfig
 *
 */

function RedirectsConfig($stateProvider) {

  'ngInject';
  
  $stateProvider
    .state('main.qqRedirect', {
      url: 'qq-redirect',
      template: '',
      controller: 'QqRedirectController',
    })
    .state('main.wechatRedirect', {
      url: 'wechat-redirect',
      template: '',
      controller: 'WechatRedirectController',
    });
}

export default RedirectsConfig;



// WEBPACK FOOTER //
// ./app/pages/social-redirects/social-redirects.config.js